import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "../better/banner.module.scss"

const BetterBanner = props => {
  const data = props.data.strapiBotanicalReset
  return (
    <div className={styles.banner}>
      <div className={styles.banner__overlay}></div>
      <Container>
        <div className={styles.banner__content}>
          <p>{data.BannerSubHeading}</p>
          <h1>{data.BannerHeading}</h1>
          <div>
            {data.BannerCtas.map((btn, key) => (
              <a href={btn.ButtonLink} className="cta" key={key}>
                {btn.ButtonText}
              </a>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default BetterBanner
